export default function DashboardFilled({ className }) {
    return (
      <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="2.7"
                y="2.7"
                width="5.87305"
                height="5.87305"
                rx="1.3"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.4" />
          <rect x="2.7"
                y="11.4266"
                width="5.87305"
                height="5.87305"
                rx="1.3"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.4" />
          <rect x="11.4266"
                y="2.7"
                width="5.87305"
                height="5.87305"
                rx="1.3"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.4" />
          <rect x="11.4266"
                y="11.4266"
                width="5.87305"
                height="5.87305"
                rx="1.3"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.4" />
      </svg>

    )
}
